export default function initUsageSolutionsCarousel(Swiper, Navigation, Autoplay) {
    // ==========================================================
    // USAGE SOLUTIONS
    // ==========================================================

    const usageSolutions = document.querySelectorAll("[data-usage-solutions]");

    usageSolutions.forEach((section) => {
        const tabs = section.querySelectorAll("[data-usage-tab]");

        const panels = section.querySelectorAll("[data-usage-panel]");

        const swipers = [];

        // ======================================================
        // SWIPERS
        // ======================================================

        panels.forEach((panel, index) => {
            const slider = panel.querySelector("[data-usage-slider]");

            if (!slider) {
                return;
            }

            const prev = slider.querySelector(".usage-solutions__arrow--prev");

            const next = slider.querySelector(".usage-solutions__arrow--next");

            const swiper = new Swiper(slider, {
                modules: [Navigation, Autoplay],
                loop: true,
                watchOverflow: true,
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                },
                observer: true,

                observeParents: true,

                slidesPerView: 1.15,

                spaceBetween: 16,

                navigation: {
                    prevEl: prev,
                    nextEl: next,
                },

                breakpoints: {
                    640: {
                        slidesPerView: 1.6,
                        spaceBetween: 20,
                    },

                    768: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },

                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                    },

                    1300: {
                        slidesPerView: 4,
                        spaceBetween: 24,
                    },
                },
            });

            swipers[index] = swiper;
        });

        // ======================================================
        // TABS
        // ======================================================

        tabs.forEach((tab) => {
            tab.addEventListener("click", () => {
                const index = Number(tab.dataset.usageTab);

                tabs.forEach((item) => {
                    item.classList.remove("is-active");
                });

                panels.forEach((panel) => {
                    panel.classList.remove("is-active");
                });

                tab.classList.add("is-active");

                const activePanel = panels[index];

                if (activePanel) {
                    activePanel.classList.add("is-active");
                }

                if (swipers[index]) {
                    requestAnimationFrame(() => {
                        swipers[index].update();
                    });
                }
            });
        });
    });
}
